import { addMonths, addQuarters } from "date-fns";

import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import { SimpleCondition } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import { FORECAST_COLUMNS_PER_PAGE } from "@app/scene/deal/util/consts";
import { DealFieldName } from "@app/util/fieldModel/DealFieldModel";

import ForecastViewMode from "../enum/ForecastViewMode";

import { endOf, startOf } from "./forecastPeriodBounds";

const add: Record<ForecastViewMode, (date: Date | number, amount: number) => Date> = {
  [ForecastViewMode.MONTH]: addMonths,
  [ForecastViewMode.QUARTER]: addQuarters,
};

const getNextClosingDateFilterByModeAndColumns = (
  viewMode: ForecastViewMode,
  startColumn: number = 0
): SimpleCondition => ({
  fieldFilterName: DealFieldName.CLOSING_DATE,
  operator: FilterOperator.IN_RANGE,
  value: [
    startOf[viewMode](add[viewMode](Date.now(), startColumn)).toISOString(),
    endOf[viewMode](
      add[viewMode](Date.now(), startColumn + FORECAST_COLUMNS_PER_PAGE - 1)
    ).toISOString(),
  ],
});

export default getNextClosingDateFilterByModeAndColumns;
